import { load } from '@/router/routes/index';

export default [
    {
        path: 'articles',
        name: 'article.index',
        component: load('article/ArticleIndex'),
        meta: { auth: true },
    },
    {
        path: 'articles/create',
        name: 'article.create',
        component: load('article/ArticleCreate'),
        meta: { auth: true, forceCollapsedMenu: true },
    },
    {
        path: 'articles/:articleId',
        component: load('article/ArticleDetail'),
        meta: { auth: true },
        children: [
            {
                path: '',
                component: load('article/ArticleShow'),
                meta: { auth: true },
                children: [
                    {
                        path: '',
                        name: 'article.show',
                        component: load('article/ArticleShowOverview'),
                        meta: { auth: true },
                    },
                ],
            },
            {
                path: 'edit',
                name: 'article.edit',
                component: load('article/ArticleEdit'),
                meta: { auth: true, forceCollapsedMenu: true },
            },
        ],
    },

    {
        path: 'price-lists',
        name: 'pricelist.index',
        component: load('article/PriceListIndex'),
        meta: { auth: true },
    },
    {
        path: 'price-lists/create',
        name: 'pricelist.create',
        component: load('article/PriceListCreate'),
        meta: { auth: true, forceCollapsedMenu: true },
    },
    {
        path: 'price-lists/:priceListId',
        component: load('article/PriceListDetail'),
        meta: { auth: true },
        children: [
            {
                path: '',
                component: load('article/PriceListShow'),
                meta: { auth: true },
                children: [
                    {
                        path: '',
                        name: 'pricelist.show',
                        component: load('article/PriceListShowOverview'),
                        meta: { auth: true },
                    },
                    {
                        path: 'articles',
                        name: 'pricelist.show.articles',
                        component: load('article/PriceListShowArticle'),
                        meta: { auth: true },
                    },
                ],
            },
            {
                path: 'edit',
                name: 'pricelist.edit',
                component: load('article/PriceListEdit'),
                meta: { auth: true, forceCollapsedMenu: true },
            },
        ],
    },



    {
        path: 'categories/create',
        name: 'category.create',
        component: load('article/CategoryCreate'),
        meta: { auth: true, forceCollapsedMenu: true },
    },
    {
        path: 'divisions/create',
        name: 'division.create',
        component: load('article/DivisionCreate'),
        meta: { auth: true, forceCollapsedMenu: true },
    },
    {
        path: 'groups/create',
        name: 'group.create',
        component: load('article/GroupCreate'),
        meta: { auth: true, forceCollapsedMenu: true },
    },
    {
        path: 'lines/create',
        name: 'line.create',
        component: load('article/LineCreate'),
        meta: { auth: true, forceCollapsedMenu: true },
    },
    {
        path: 'brands/create',
        name: 'brand.create',
        component: load('article/BrandCreate'),
        meta: { auth: true, forceCollapsedMenu: true },
    },
    {
        path: 'types/create',
        name: 'type.create',
        component: load('article/TypeCreate'),
        meta: { auth: true, forceCollapsedMenu: true },
    },
];
